import { render, staticRenderFns } from "./service-archive.vue?vue&type=template&id=ff6e4ca2&scoped=true&"
import script from "./service-archive.vue?vue&type=script&lang=js&"
export * from "./service-archive.vue?vue&type=script&lang=js&"
import style0 from "./service-archive.vue?vue&type=style&index=0&id=ff6e4ca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6e4ca2",
  null
  
)

export default component.exports